import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex flex-col min-h-screen" data-id="element-121" data-mp="kzvf3jsbaucg">
      <Navbar data-id="element-122" data-mp="zxnwkhhf5sta" />
      <main className="flex-grow" data-id="element-123" data-mp="zwctkjvssp38">{children}</main>
      <Footer data-id="element-124" data-mp="zv1n2cayx38f" />
    </div>;
}